import { Pipe, PipeTransform, inject, Optional } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import { ThemeService } from '../../services/theme.service';


@Pipe({
    name: 'sanitizeHtml',
    standalone: true
})
export class SanitizeHtmlPipe implements PipeTransform {

  private themeService = inject(ThemeService, { optional: true });

  constructor(protected sanitizer: DomSanitizer) {}

 public transform(value: any, options?: string): any {
     let sanitizedContent: string;
     
     if (options === 'youtubeEmbed') {
       sanitizedContent = DOMPurify.sanitize(value, {
         ALLOWED_TAGS: [
           'div', 'span', 'p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
           'ul', 'ol', 'li', 'a', 'img', 'iframe', 'style'
         ],
         ALLOWED_ATTR: [
           'class', 'id', 'style', 'src', 'frameborder', 'allowfullscreen', 'width', 'height',
           'href', 'target', 'alt', 'title'
         ],
         ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
         ADD_TAGS: ['style'],
         ADD_ATTR: ['style']
       });
     } else {
       sanitizedContent = DOMPurify.sanitize(value);
     }
     
     // Strip color-related inline styles in dark mode
     if (this.themeService?.isDarkMode()) {
       sanitizedContent = this.stripColorStyles(sanitizedContent);
     }
     
     return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }

  private stripColorStyles(html: string): string {
    // Remove color-related CSS properties from inline styles
    return html.replace(/style="([^"]*)"/g, (match, styleContent) => {
      // Remove color-related properties
      const cleanedStyle = styleContent
        .replace(/color\s*:\s*[^;]+;?/gi, '')
        .replace(/background-color\s*:\s*transparent;?/gi, '')
        .replace(/;\s*;/g, ';') // Clean up double semicolons
        .replace(/^;|;$/g, '') // Remove leading/trailing semicolons
        .trim();
      
      // If there's no style content left, remove the style attribute entirely
      if (!cleanedStyle) {
        return '';
      }
      
      return `style="${cleanedStyle}"`;
    });
  }
}